import React from 'react'
import FormattedPrice from '@components/FormattedPrice'
import { useTranslation } from 'react-i18next'

interface Props {
  price: number
  priceUndiscounted: number
  currency: string
}

const VariantPrice: React.FC<Props> = ({ price, priceUndiscounted, currency }) => {
  const { t } = useTranslation()
  const isSale = priceUndiscounted !== price
  return (
    <div className='flex flex-col items-end text-right'>
      <div className='flex items-baseline gap-4'>
        <span itemProp='price' className={`price__value text-bold ${isSale ? 'line-through' : ''}`}>
          <FormattedPrice currency={currency} amount={priceUndiscounted} />
        </span>
        <span className='text-gray-700 text-sm'>{t('each', 'each')}</span>
      </div>
      {isSale && (
        <span className='text-red'>
          <FormattedPrice currency={currency} amount={price} />
        </span>
      )}
    </div>
  )
}

export default VariantPrice
